export default __webpack_public_path__ + "static/192@2x-d206f29a97a4ba6721372f91a223f8c6.jpg";